c7-news-show-all {
  width: fit-content;

  a {
    display: inline-block;
    color: var(--c7-500);
    padding: .5rem 1rem;
    border: 1px solid var(--c7-500);
    cursor: pointer;
    text-decoration: none;
    text-transform: uppercase;
    transition: all .3s ease-in-out;
    white-space: nowrap;

    &:hover, &:focus {
      outline: none;
      background-color: var(--c7-500);
      color: var(--c7-500-contrast);
    }
  }

}
